export default {
  password: 'required|containsLowerCaseLetters:1|containsUpperCaseLetters:1|containsNumbers:1|min:8',
  sortcode: 'required|isSortcode',
  bank_account_uk: 'required|isUKBAN',
};
